import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SignUpService {
  private readonly baseUrl = `${environment.backend.url}/api/user/v1`;

  constructor(private readonly http: HttpClient) { }

  public signUpUser(body: any, recaptchaToken: string) {
    return this.http.post(`${this.baseUrl}/signup`, body, {
      headers: {
        'x-recaptcha-token': recaptchaToken,
      }
    });
  }
}
